import { CompactTable, CustomField } from '@mss/mss-component-library';
import { TFunction } from 'i18next';

export const emptyCustomField: CustomField = {
  id: '',
  choices: [],
  created_at: '',
  updated_at: '',
  deleted: false,
  center_synced_at: '',
  model: '',
  field_type: '',
  name: '',
  description: '',
  slug: '',
  required: false,
  site: '',
  placeholder: '',
};

export const fieldTypeOptions: (t: TFunction) => {
  key: string;
  value: string;
}[] = (t: TFunction) => [
  { key: t('Integer'), value: 'integer' },
  { key: t('String'), value: 'string' },
  { key: t('Boolean'), value: 'boolean' },
  { key: t('IP-address'), value: 'ip_address' },
  { key: t('User / Group'), value: 'user_group' },
  { key: t('Date / Time'), value: 'date_time' },
];

export const modelTypes = [
  {
    model: 'ApplicationAsset',
    name: 'Application Asset',
    display_name: 'Security Application',
  },
  {
    model: 'ControlApplication',
    name: 'Control Application',
    display_name: 'Control Application',
  },
  {
    model: 'AssetManagementApplication',
    name: 'Asset Management Application',
    display_name: 'Asset Management Application',
  },
  {
    model: 'ComputeAsset',
    name: 'Compute Asset',
    display_name: 'Compute Asset',
  },
  {
    model: 'DCSPLCAsset',
    name: 'Dcsplc Asset',
    display_name: 'PLC/DCS Asset',
  },
  {
    model: 'EnvAsset',
    name: 'Environmental Asset',
    display_name: 'Environmental Asset',
  },
  {
    model: 'FieldAsset',
    name: 'Field Asset',
    display_name: 'Field Asset',
  },
  {
    model: 'NetworkAsset',
    name: 'Network Asset',
    display_name: 'Network Asset',
  },
  {
    model: 'AnalyzerManagementApplication',
    name: 'Analyzer Management Application',
    display_name: 'Analyzer Management Application',
  },
  {
    model: 'VirtualizationApplication',
    name: 'Virtualization Application',
    display_name: 'Virtualization Application',
  },
];

export const useAllAssetsText = 'Use all applicable assets / applications';
export const searchForAssetsText = 'Search for specific assets / applications';
export const useIdFromTriggerText = 'Use MSS Asset ID from trigger';

export const StyledCompactTable = CompactTable;

export const isNumeric = (n: any) => {
  if (!isNaN(parseInt(n)) && isFinite(n)) {
    return parseInt(n) === parseFloat(n);
  }
  return false;
};

export const isIPAddress = (address: any) => {
  const ip4 =
    '(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
  const ip6 =
    '(([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))';
  const all_conditions = `(^\\s*(${ip4})\\s*$)|(^\\s*(${ip6})(%.+)?\\s*$)`;
  const rx = new RegExp(all_conditions);
  return rx.test(address);
};

export const conditionsRefactor = (value: any) => {
  if (value?.conditions.length > 0) {
    return {
      ...value,
      conditions: { operator: 'AND', conditions: value.conditions },
    };
  }

  return value;
};

export const checkForEmptyAssetId = (value: any) => {
  if (
    value?.trigger.settings.asset_id === 'empty' ||
    value?.trigger.settings.asset_id === useAllAssetsText
  ) {
    const newValue = value;
    newValue.trigger.settings.asset_id = '';
    return newValue;
  }
  return value;
};
